<template>
  <div>
    <div class="inner-header">
      <nav class="navbar fixed-top animate__animated animate__slideInRight">
        <a @click="$router.go(-1)" class="back-arrow">
          <svg xmlns="http://www.w3.org/2000/svg" width="17.368" height="16.365" viewBox="0 0 17.368 16.365">
            <g id="Group_38360" data-name="Group 38360" transform="translate(-27.632 -34.814)" opacity="1">
              <line id="Line_124" data-name="Line 124" x2="16" transform="translate(29 43)" fill="none" stroke="#000"
                stroke-width="2" />
              <path id="Path_51451" data-name="Path 51451" d="M.033,0l-7,7.425L.033,15"
                transform="translate(35.967 35.5)" fill="none" stroke="#000" stroke-width="2" />
            </g>
          </svg>
        </a>
        <a href="javascript:void(0);" class="link-title">My Visiting Card</a>
      </nav>
    </div>
    <div class="main-wrapper" v-if="visitingCardData">
      <!-- Visiting Card Image -->
      <img :src="imageData" v-if="imageData" />

      <!-- visiting card html -->
      <div class="card" id="capture" style="position: absolute; left: -9999px;">
        <div class="header">
          <div class="content">
            <div>
              <h1>{{ visitingCardData.name }}</h1>
              <p>{{ visitingCardData.current_designation }}</p>
            </div>
            <div>
              <img src="@/assets/logo.png" alt="Logo" class="img-fluid logo" height="70" width="300" />
            </div>
          </div>
        </div>
        <div class="contact">
          <div class="contact-row phone-sec">
            <img src="@/assets/call1.svg" alt="phone">
            <a :href="`tel:${visitingCardData.phone}`">{{ visitingCardData.phone }}</a>
            <span>
              <img src="@/assets/email1.svg" alt="mail" class="mail-icon">
              <a :href="`mailto:${visitingCardData.email}`">
                {{ visitingCardData.email }}
              </a>
            </span>
          </div>
          <div class="contact-row address mt-4">
            <img src="@/assets/location.svg" alt="location">
            <span>
              {{ visitingCardData.office_address }}
            </span>
          </div>
        </div>

      <div class="card-middle">
          <div class="manager" v-if="visitingCardData.tlname">
            <div class="manager-details">
              <img src="@/assets/user.svg" alt="mail"><p><span style="max-width: 725px;">{{
                  visitingCardData.tlname }} <span class="designation">– {{
                    visitingCardData.tl_designation }}</span></span></p>
            </div>
            <div class="manager-details">
              <img src="@/assets/call2.svg" alt="phone"><p class="manager-contact">{{
                visitingCardData.tl_phone }}</p>
            </div>
            <div class="manager-details">
             <img src="@/assets/email2.svg" alt="mail"><p class="manager-contact">{{visitingCardData.tl_email}}</p>
            </div>
          </div>

          <div class="qr">
            <QrcodeVue :value="vcard" :size="168" level="H" render-as="svg" v-if="vcard" />
          </div>
        </div>

        <div class="visit-card-footer">
          <p class="footer-item"><img src="@/assets/website.svg" width="26" height="26" alt=""> <a
              href="https://www.propertypistol.com">www.propertypistol.com</a></p>
          <p class="footer-item"><img src="@/assets/call.svg" alt="mail" width="26" height="26">
            <a href="mailto:support@propertypistol.com">
              support@propertypistol.com
            </a>
          </p>
        </div>
      </div>

      <!-- Download and Share -->
      <div class="action-container">
        <div class="action-card" @click="whatsappShare">
          <span class="label">Share on</span>
          <div class="action">
            WhatsApp
            <img src="@/assets/whatsapp-icon.svg" alt="whatsapp">
          </div>
        </div>

        <div class="action-card" @click="downloadVisitingCard">
          <span class="label">Save image</span>
          <div class="action">
            Download
            <img src="@/assets/visit-download-icon.svg" alt="download">
          </div>
        </div>
      </div>

      <!-- QR code -->
      <div class="qr-code">
        <div class="qr-sec">
          <QrcodeVue :value="vcard" :size="168" level="H" render-as="svg" v-if="vcard" />
        </div>
        <p>Share your card or let customers scan this QR to share your number</p>
      </div>
    </div>
  </div>
</template>
<script>
import html2canvas from "html2canvas";
import QrcodeVue from 'qrcode.vue'
export default {
  name: 'VisitingCard',
  components: {
    QrcodeVue
  },
  mounted() {
    this.getVisitingCardData();
  },
  computed: {
    // ID of User
    userId() {
      return localStorage.getItem('radiate-user-id');
    },
    // QR code data
    vcard() {
      const data = this.visitingCardData || {};
      return `BEGIN:VCARD
VERSION:3.0
N:${data.name || ''};;;
FN:${data.name || ''}
ORG:Syndicate by PropertyPistol
TITLE:${data.current_designation || ''}
TEL;TYPE=CELL:${data.phone || ''}
EMAIL;TYPE=WORK:${data.email || ''}
ADR;TYPE=WORK:;;${data.office_address || ''};;;;
URL:https://www.propertypistol.com/syndicate
END:VCARD`;
    }
  },
  data() {
    return {
      imageData: null,
      visitingCardData: null,
    };
  },
  methods: {
    // get employee Details
    async getVisitingCardData() {
      if (!this.userId) return;
      this.$axios.get(`/users/${this.userId}/visiting_card_detail`).then((res) => {
        let userData = res?.data?.user_data || null;
        this.visitingCardData = {
          name: userData.name || '',
          current_designation: userData.current_designation || '',
          phone: userData.phone || '',
          email: userData.email || '',
          office_address: userData.office_address || '',
          tlname: userData.tl_details?.name || '',
          tl_designation: userData.tl_details?.current_designation || '',
          tl_phone: userData.tl_details?.phone || '',
          tl_email: userData.tl_details?.email || '',
        };
      }).catch((err) => {
        swal({
          title: "Error",
          text: 'Something Went Wrong!!',
          icon: "error"
        });
      }).finally(() => {
        if (this.visitingCardData)
          this.generateHtmlToImage();
      });
    },

    // generate HTML to Image
    async generateHtmlToImage() {
      const element = document.getElementById("capture");
      const canvas = await html2canvas(element, {
        scale: 2,
        useCORS: true,
        backgroundColor: null,
      });
      this.imageData = canvas.toDataURL("image/png");
    },

    // Download the visiting card as Image
    downloadVisitingCard() {
      const link = document.createElement("a");
      link.href = this.imageData;
      link.download = `${this.visitingCardData?.name}-vcard.png`;
      link.click();
    },

    // Share on WhatsApp
    async whatsappShare() {
      if (!this.imageData) return;

      // Convert base64 string to File
      const arr = this.imageData.split(',');
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      const file = new File([u8arr], `${this.visitingCardData?.name}-vcard.png`, { type: mime });

      // Use Web Share API
      try {
        await navigator.share({
          title: "My Visiting Card",
          text: "Check this out!",
          files: [file],
        });
      } catch (err) {
        swal({
          title: "Sharing failed",
          text: 'Please download the image first, then attach it in WhatsApp to share.',
        });
        console.error("Error", err);
      }
    }
  }
};
</script>

<style scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  background-color: #999999;
  font-family: "Poppins", sans-serif;
}

.card {
  border-radius: 33px;
  width: 1050px;
  margin: 0 auto;
  border: 0 !important;
  background-color: transparent;
  box-shadow: none;
  padding: 0;
}

.main-wrapper {
  margin: 62px 0 0;
  padding: 10px;
}

.main-wrapper img {
  max-width: 100%;
  height: auto;
}

.header {
  display: flex;
  justify-content: space-around;
}

.header .content {
  background-color: #FFFFFF;
  padding: 40px;
  clear: both;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header .content h1 {
  font-weight: 700;
  font-size: 40px;
  line-height: 63px;
  color: #000000;
}

.header .content p {
  text-transform: uppercase;
  color: #BF441C;
  font-weight: 600;
  font-size: 24px;
  line-height: 40px;
}

.contact {
  padding: 20px 40px;
  background-color: #fff;
}

.contact a {
  color: #000;
}

.contact-row {
  display: flex;
  align-items: baseline;
  gap: 7px;
  margin-bottom: 8px;
  font-size: 22px;
  color: #333;
  font-weight: 500;
  line-height: 40px;
}

.manager img{
  margin-bottom: 4px;
  margin-right: 7px;
}

.contact-row a {
  color: #333;
  text-decoration: none;
  font-weight: 500;
  line-height: normal;
}

.contact-row.phone-sec span {
  margin-left: 40px;
}

.address span {
  line-height: 1.4;
  max-width: 725px;
}

.card-middle {
  background: #F5F5F5;
  padding: 35px 40px;
}
.manager-details{
  display: inline-block;
}

.manager {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.manager p {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-weight: 600;
  font-size: 20px;
}

.manager span  {
  font-weight: 600;
  font-size: 20px;
  line-height: 40px;
  color: #000000;
}
.manager span.designation {
  font-weight: 400;
  font-size: 20px;
  line-height: 40px;
  color: #000000;
  opacity: 0.5;
}
.manager-contact{
  font-weight: 500 !important;
  line-height: 40px;
}

.qr {
  position: absolute;
  right: 40px;
  bottom: 27px;
  padding: 6px;
  background-color: #ffffff;
  border: 9px solid #EB5218;
  border-radius: 10px;
}

.visit-card-footer {
  background: #EB5218;
  display: flex;
  justify-content: flex-start;
  gap: 100px;
  padding: 16px 100px;
  font-size: 14px;
}

.visit-card-footer a {
  color: #FFFFFF;
  margin-bottom: 2px;
}

.action-container {
  display: flex;
  gap: 20px;
  padding: 20px;
  justify-content: center;
}

.action-card {
  background: #fff;
  padding: 14px 22px;
  box-shadow: 0px 1px 4px 0px #0000001A;
  min-width: 150px;
  cursor: pointer;
  border-radius: 8px;
  padding: 8px 16px;
}

.label {
  display: block;
  font-weight: 400;
  font-size: 12px;
  color: #808080;

}

.action {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #000000;
  font-weight: 500;
  font-size: 14px;
}

.action img {
  width: 16px;
  height: 16px;
}

.qr-code {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 10px;
  margin-top: 80px;
}

.qr-code p {
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: #000000;
}

.qr-code .qr-sec {
  border: 9px solid #ffffff;
  border-radius: 10px;
}

.footer-item {
  display: flex;
  align-items: center;
  gap: 2px;
}
</style>
